import { useState } from 'react';

import {
  SendSmsEnrollmentMutation,
  useSendSmsEnrollmentMutation,
} from '@app/widgets/contacts-and-settings/queries/queryTyping/sendSmsEnrollment';

const RESEND_LOADER_PENDING = 1000;

export const useResendSms = () => {
  const [sendSms] = useSendSmsEnrollmentMutation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState<SendSmsEnrollmentMutation>();

  const resendSms: typeof sendSms = (...args) => {
    setLoading(true);

    const startTimer = new Promise<SendSmsEnrollmentMutation>((resolve) => {
      setTimeout(resolve, RESEND_LOADER_PENDING);
    });
    return Promise.all([startTimer, sendSms(...args)])
      .then(([, payload]) => {
        setData(payload?.data!);

        return payload;
      })
      .catch((err) => {
        setError(err);
        throw err;
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return [
    resendSms,
    {
      error,
      data,
      loading,
    },
  ] as ReturnType<typeof useSendSmsEnrollmentMutation>;
};
